module.exports = __webpack_public_path__ + "static/img/tea_page.05330d2f.png";